import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/apps/home/router';
import Product from './apps/product/router';
import Solution from './apps/solution/router';
import AboutUs from './apps/aboutUs/router';
import Condition from './apps/condition/router';

Vue.use(Router);


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    Home,
    Product,
    Solution,
    AboutUs,
    Condition,
  ],
  srcollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    }
    return true;
  },
});


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = 'PHOENIX - 官网';
  }
  next();
});

export default router;
